export const getNbMaxFromValidation = (validation) => {
  const nbMaxInfo = validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'nbMax')
  );
  return nbMaxInfo && nbMaxInfo.nbMax ? nbMaxInfo.nbMax : -1;
};

export const getFormValidationDateMin = (field, model): FormValidation => {
  const value = model.value[field.name]?.value;
  let validated: boolean = false;
  const validation = field.validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'min')
  );
  const applyRule: boolean = (validation && validation.min) || false;

  if (!applyRule) {
    validated = true;
  } else {
    const date = new Date(value);
    validated = date < new Date(validation.min);
  }

  const message = !validated ? validation.message : '';

  return {
    applyRule,
    validated,
    message,
  };
};

export const getFormValidationNbMax = (field, model): FormValidation => {
  const value = model.value[field.name]?.value;
  let validated: boolean = false;

  const validation = field.validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'nbMax')
  );

  let length = value ? value.length : 0;

  const multiple = Object.prototype.hasOwnProperty.call(field, 'multiple')
    ? field.multiple
    : false;

  if (!multiple) {
    length = length > 0 ? 1 : 0;
  }

  const applyRule =
    validation !== undefined &&
    validation?.nbMax !== null &&
    validation.nbMax > 0;

  if (!applyRule) {
    validated = true;
  } else {
    validated = length <= validation.nbMax;
  }
  const message = !validated ? validation.message : '';
  return { applyRule, validated, message };
};
export const getFormValidationRequired = (field, model): FormValidation => {
  const value = model.value[field.name]?.value;
  let validated: boolean = false;
  const validation = field.validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'required')
  );
  const applyRule: boolean = (validation && validation.required) || false;

  let length;
  if (field.type === 'boolean') {
    if (field.template === 'rgpd') {
      length = typeof value === 'boolean' ? 1 : 0;
    } else {
      length = typeof value === 'boolean' && value === true ? 1 : 0;
    }
  } else if (value == null) {
    length = 0;
  } else {
    const test = String(value);
    length = test.length;
  }

  if (!applyRule) {
    validated = true;
  } else {
    validated = length > 0;
  }

  const message = !validated ? validation.message : '';

  return {
    applyRule,
    validated,
    message,
  };
};

export const getFormValidationRegExps = (field, model): FormValidation => {
  const value = model.value[field.name]?.value;
  let validated: boolean = false;
  const validations = [];
  field.validation.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'pattern')) {
      validations.push(item);
    }
  });
  const text = value != null ? value : '';
  return validations.reduce(
    (acc, validation) => {
      const applyRule = validation.pattern !== null && text !== '';
      if (!applyRule) {
        validated = true;
      } else {
        validated = new RegExp(validation.pattern).test(text);
      }
      if (!validated) {
        acc.messages.push(validation.message);
        acc.validated = false;
      }
      if (applyRule) {
        acc.applyRule = applyRule;
      }
      return acc;
    },
    {
      applyRule: false,
      validated: true,
      messages: [],
    }
  );
};

export const getFormValidationMatches = (field, model): FormValidation => {
  const value = model.value[field.name]?.value || '';
  let validated: boolean = false;
  const validation = field.validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'matches')
  );

  const applyRule = validation && validation.matches !== null;
  if (!applyRule) {
    validated = true;
  } else {
    const valueToMatch = model.value[validation.matches]?.value || '';
    validated = valueToMatch === value;
  }
  const message = !validated ? validation.message : '';
  return {
    applyRule,
    validated,
    message,
  };
};

export const isFormFieldValidate = (field, model): boolean => {
  if (!field.validation) return true; // if no validation rules it s ok baby (example for referal code) !
  if (!getFormValidationNbMax(field, model).validated) return false;
  if (!getFormValidationRegExps(field, model).validated) return false;
  if (!getFormValidationRequired(field, model).validated) return false;
  if (!getFormValidationDateMin(field, model).validated) return false;
  if (!getFormValidationMatches(field, model).validated) return false;
  return true;
};

export const isFieldRequired = (field: FormField) => {
  if (!field.validation) return false;
  const validation = field.validation.find((item) =>
    Object.prototype.hasOwnProperty.call(item, 'required')
  );
  return (validation && validation.required) || false;
};
